import { HTTP_CP_ClientUser } from '@api-new/userservice';
import { DashboardWidgetType } from '@platform/dashboard/enums/dashboard-news-banner-type.enum';
import { DashboardWidget } from '@platform/dashboard/models/dashboard-news-banner.model';
import { PropertiesPortfolioItem } from '@platform/portfolio/models/properties-portfolio-item.model';

// Add a widget indicating a 'best deal' is available
export const addBestDealWidget = (portfolioItem: PropertiesPortfolioItem, dashboardWidgets: DashboardWidget[]): void => {
  dashboardWidgets.push({
    type: DashboardWidgetType.HAS_DEAL,
    property: portfolioItem.property,
    mortgage: portfolioItem.mortgage,
  });
};

// Add a widget for an active mortgage case
export const addActiveMortgageCaseWidget = (portfolioItem: PropertiesPortfolioItem, dashboardWidgets: DashboardWidget[]): void => {
  dashboardWidgets.push({
    type: DashboardWidgetType.HAS_ACTIVE_CASE,
    mortgage: portfolioItem.mortgage,
  });
};

// Add a widget if the mortgage term is expiring soon (within 9 months)
export const addMortgageWidgetsIfExpiringSoon = (portfolioItem: PropertiesPortfolioItem, dashboardWidgets: DashboardWidget[]): void => {
  if (
    portfolioItem.mortgage.numberOfMonthsToLastEarlyRepaymentChargeEndDate <= 9 &&
    portfolioItem.mortgage.numberOfMonthsToLastEarlyRepaymentChargeEndDate >= 0
  ) {
    dashboardWidgets.push({
      type: DashboardWidgetType.MORTGAGE_EXPIRATION,
      property: portfolioItem.property,
      mortgage: portfolioItem.mortgage,
    });
  }
};

// Add a widget if there's a mortgage but no best deal, depending on user data completeness
export const addMortgageWithoutDealWidget = (dashboardWidgets: DashboardWidget[], clientUser: HTTP_CP_ClientUser): void => {
  const userHasMissingInformation = !Object.keys(clientUser.clientUserEmployment).length;
  dashboardWidgets.push({
    type: userHasMissingInformation
      ? DashboardWidgetType.MORTGAGE_WITH_NO_CASE_AND_DATA_FILLED
      : DashboardWidgetType.MORTGAGE_WITH_NO_CASE_AND_MINIMAL_DATA,
  });
};

// Add landlord-specific widgets
export const addLandlordWidgets = (
  clientUser: HTTP_CP_ClientUser,
  numberOfClientProperties: number,
  dashboardWidgets: DashboardWidget[],
): void => {
  if (clientUser.showDeclaredPropertyBanner === true && clientUser.declaredNumberOfProperties > numberOfClientProperties) {
    dashboardWidgets.push({ type: DashboardWidgetType.LANDLORD_ADD_PROPERTIES });
  }
};

// Add empty account widgets
export const addEmptyAccountWidgets = (dashboardWidgets: DashboardWidget[]): void => {
  dashboardWidgets.push({ type: DashboardWidgetType.ADD_PROPERTY });
};

// Add smart search widget
export const addSmartSearchWidget = (dashboardWidgets: DashboardWidget[]): void => {
  dashboardWidgets.push({ type: DashboardWidgetType.ADD_SMART_SEARCH });
};

// Add EPC improvements widget if EPC available
export const addEpcImprovementsWidget = (portfolioItem: PropertiesPortfolioItem, dashboardWidgets: DashboardWidget[]): void => {
  const epc = portfolioItem.property.energyPerformanceCertificate;
  if (epc == null || epc.energyEfficiencyCurrent === epc.energyEfficiencyPotential) return;
  dashboardWidgets.push({ type: DashboardWidgetType.EPC_IMPROVEMENTS, property: portfolioItem.property });
};
